module.exports = __webpack_public_path__ + "static/media/link4.20bcb5aa.svg";